"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNKNOWN_ENV = exports.LOCAL_ENV = exports.LOAD_ENV = exports.DEV_ENV = exports.BETA_ENV = exports.STAGING_ENV = exports.PROD_ENV = void 0;
const getAppHostConfig_1 = __importStar(require("./getAppHostConfig"));
const PROD_ENV = 'prod';
exports.PROD_ENV = PROD_ENV;
const STAGING_ENV = 'staging';
exports.STAGING_ENV = STAGING_ENV;
const BETA_ENV = 'beta';
exports.BETA_ENV = BETA_ENV;
const DEV_ENV = 'dev';
exports.DEV_ENV = DEV_ENV;
const LOAD_ENV = 'load';
exports.LOAD_ENV = LOAD_ENV;
const LOCAL_ENV = 'local';
exports.LOCAL_ENV = LOCAL_ENV;
const UNKNOWN_ENV = 'unknown';
exports.UNKNOWN_ENV = UNKNOWN_ENV;
exports.default = () => {
    const { BASE_HOST } = getAppHostConfig_1.default();
    if (BASE_HOST === 'atms.a2z.com') {
        return PROD_ENV;
    }
    else if (BASE_HOST === 'staging.atms.a2z.com') {
        return STAGING_ENV;
    }
    else if (BASE_HOST === 'beta2.atms.a2z.com') {
        return BETA_ENV;
    }
    else if (BASE_HOST === 'dev.atms.a2z.com') {
        return DEV_ENV;
    }
    else if (BASE_HOST === 'load.atms.a2z.com') {
        return LOAD_ENV;
    }
    else if (BASE_HOST === 'local.atms.a2z.com' || getAppHostConfig_1.isSingleOriginHost(BASE_HOST)) {
        return LOCAL_ENV;
    }
    else {
        return UNKNOWN_ENV;
    }
};
//# sourceMappingURL=inferEnvironment.js.map